import { isFullArray } from '@shared/lib/array'
import { getQuerySearchParam } from '@shared/lib/query'

import { type RouteLocationNormalizedGeneric, useRoute } from '#vue-router'

const DEFAULT_SOURCE = 'Landing'

export const getSourceTypeFromUrl = (routeFromParams?: RouteLocationNormalizedGeneric): string[] => {
  const windowSource = typeof window !== 'undefined' ? getQuerySearchParam('source') : null

  const route = routeFromParams || useRoute()
  const querySource = route?.query?.source
  const routeSource = isFullArray(querySource)
    ? querySource.filter(Boolean).join(',')
    : querySource

  const source = routeSource || windowSource

  return [source ? `${source}` : DEFAULT_SOURCE]
}
